export const socketInitialState: {
  connected: boolean;
  connections: {
    [key: string]: boolean;
  };
  stream: {
    [key: string]: {
      price: number;
      prevPrice: number;
      bid: number;
      prevBid: number;
      ask: number;
      prevAsk: number;
    };
  };
} = {
  connected: false,
  connections: {},
  stream: {},
};
